/**
 * Masks an email address for display, e.g. michael@gmail.com → m***l@gmail.com
 * @param {string} email
 * @returns {string}
 */
export function maskEmail (email) {
    if (!email || typeof email !== 'string') {
        return '';
    }

    const trimmed = email.trim();
    const atIndex = trimmed.indexOf('@');

    if (atIndex <= 0 || atIndex === trimmed.length - 1) {
        return trimmed;
    }

    const localPart = trimmed.slice(0, atIndex);
    const domain = trimmed.slice(atIndex + 1);

    if (localPart.length === 1) {
        return `${localPart[0]}***@${domain}`;
    }

    if (localPart.length === 2) {
        return `${localPart[0]}***${localPart[1]}@${domain}`;
    }

    return `${localPart[0]}***${localPart[localPart.length - 1]}@${domain}`;
}
